const formats = [
  {
    icon: "ri-building-4-line",
    title: "In-Person Training",
    subtitle: "Nairobi, Kenya",
    desc: "Attend structured classes and workshops at our Nairobi training center. Benefit from face-to-face instruction, peer collaboration, and a focused learning environment.",
    highlight: true,
  },
  {
    icon: "ri-computer-line",
    title: "Online Learning",
    subtitle: "Access Worldwide",
    desc: "Access our full digital curriculum from anywhere in the world. Structured modules, recorded sessions, and interactive resources available on your schedule.",
    highlight: false,
  },
  {
    icon: "ri-presentation-line",
    title: "Workshops",
    subtitle: "Hands-On Sessions",
    desc: "Participate in focused, topic-specific workshops that dive deep into key areas of futures trading, market analysis, and investor readiness.",
    highlight: false,
  },
  {
    icon: "ri-live-line",
    title: "Live Webinars",
    subtitle: "Interactive & Engaging",
    desc: "Join live webinar sessions with instructors and guest experts. Ask questions in real time and engage with a community of learners across the diaspora.",
    highlight: false,
  },
  {
    icon: "ri-user-voice-line",
    title: "Coaching Sessions",
    subtitle: "Personalized Guidance",
    desc: "Work directly with experienced educators and mentors through one-on-one or small group coaching sessions tailored to your learning goals.",
    highlight: false,
  },
  {
    icon: "ri-book-2-line",
    title: "Digital Learning Resources",
    subtitle: "On-Demand Library",
    desc: "Access a curated library of ebooks, guides, video lessons, and reference materials to support your learning journey at every stage.",
    highlight: false,
  },
];

export default function LearningFormats() {
  return (
    <section className="py-24 px-6 bg-[#1A2B1F] relative overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5" style={{backgroundImage: "repeating-linear-gradient(0deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 40px), repeating-linear-gradient(90deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 40px)"}} />

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            <span className="w-8 h-px bg-[#C9A961]" />
            How We Teach
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white mb-4">
            Flexible Learning Formats
          </h2>
          <p className="text-white/60 text-base max-w-2xl mx-auto font-light leading-relaxed">
            Whether you are in Nairobi or anywhere in the world, our multi-format approach ensures you can learn in the way that works best for you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((fmt) => (
            <div
              key={fmt.title}
              className={`rounded-lg p-8 border transition-all duration-300 group ${
                fmt.highlight
                  ? "bg-[#C9A961]/10 border-[#C9A961]/40 hover:bg-[#C9A961]/15"
                  : "bg-white/5 border-white/10 hover:bg-white/10 hover:border-white/20"
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full mb-5 ${fmt.highlight ? "bg-[#C9A961]/20" : "bg-white/10"}`}>
                <i className={`${fmt.icon} text-xl ${fmt.highlight ? "text-[#C9A961]" : "text-white/70"}`} />
              </div>
              <div className={`text-[10px] font-semibold uppercase tracking-widest mb-2 ${fmt.highlight ? "text-[#C9A961]" : "text-white/40"}`}>
                {fmt.subtitle}
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-white mb-3">{fmt.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed">{fmt.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
